module.exports = __webpack_public_path__ + "img/GH-kyujin-top-ozeki.8b15853c.webp";